module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-inline-add"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "maxRowspan": _vm.maxRowspan,
      "addInlineEventBool": true,
      "saveInlineEvent": _vm.showFlgDetails,
      "columnEvent": _vm.columnEvent
    }
  }), _vm._v(" "), (_vm.objs.add.rows.length > 0) ? [_c('h3', [_vm._v(_vm._s(_vm.desc.add))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.objs.add,
      "maxRowspan": _vm.maxRowspan
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cb263bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableInlineAdd.vue
// module id = 3652
// module chunks = 1